import { createBaseThemeOptions, createUnifiedTheme } from '@backstage/theme';
import { essityBrand, essityDarkSurface, essityOverlayOnDark } from './colours';
import { createEssityComponents } from './components';
import { createEssityDarkPalette } from './darkPalette';
import { createEssityPageTheme } from './essityPageTheme';
import { essityFontFamily, essityTypography } from './typography';

export const darkTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: createEssityDarkPalette(essityDarkSurface),
    typography: essityTypography,
  }),
  defaultPageTheme: 'home',
  fontFamily: essityFontFamily,
  components: createEssityComponents(essityOverlayOnDark),
  pageTheme: { home: createEssityPageTheme(essityBrand.white) },
});
